import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionGroceryShopPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionGroceryShop.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionGroceryShop.button1'),
          value: 'multiple_times_per_week',
        },
        {
          text: t('pages.onboarding.questionGroceryShop.button2'),
          value: 'once_a_week',
        },
        {
          text: t('pages.onboarding.questionGroceryShop.button3'),
          value: 'every_2_weeks',
        },
        {
          text: t('pages.onboarding.questionGroceryShop.button4'),
          value: 'once_a_month_or_less',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
